export const SET_ACTIVE_STORE_LOCATION = 'SET_ACTIVE_STORE_LOCATION';

export const setActiveStoreLocation = (location: string) => ({
    type: SET_ACTIVE_STORE_LOCATION,
    payload: { location },
});
